import React from 'react';
import { Grid, Typography } from '@mui/material';
import Data from '../../Data/PersonalInfo.json';
import { LateWrapper } from '../animation/LateWrapper';
import { DelayedWrapper } from '../animation/DelayedWrapper';

// @About `Hobbies and interests`
const Intro = () => {
  return (
    <Grid container spacing={2}>
      {Data.about.map(({ title, description }) => (
        <Grid
          item
          xs={12}
          md={6}
          xl={6}
          xxl={6}
          key={`${title}-${description}`}
          sx={{ textAlign: 'center' }}
        >
          <LateWrapper>
            <Typography variant='heading'>{title}</Typography>
          </LateWrapper>
          <Grid item xs={12} sx={{ m: 2 }}>
            <DelayedWrapper>
              <Typography variant='paragraph'>{description}</Typography>
            </DelayedWrapper>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default Intro;
